export default "__VITE_ASSET__akINTAdv__"